import * as React from 'react'
import { Grid, Paper } from '@mui/material'
import { formatDate } from 'date-fns'
import GridItem from 'src/components/grid-item/GridItem'
import { DadosEmpresaRow } from 'src/modules/serasa/serasa.pj.types'
import AcaoJudicial from './AcaoJudicial'
import Consultas from './Consultas'
import Contatos from './Contatos'
import ControleAdministracao from './ControleAdministracao'
import ControleParticipacoes from './ControleParticipacoes'
import ControleSocietario from './ControleSocietario'
import DividaVencida from './DividaVencida'
import Endereco from './Endereco'
import Identificacao from './Identificacao'
import PendenciasFinanceiras from './PendenciasFinanceiras'
import Protesto from './Protesto'

export type DadosEmpresaProps = {
    empresa: DadosEmpresaRow
}

export default function DadosEmpresa({ empresa }: DadosEmpresaProps) {
    return (
        <Paper elevation={3} style={{ padding: 10 }}>
            {empresa.identificacao && (
                <Grid container spacing={1} paddingTop={2} paddingBottom={2} paddingLeft={5} paddingRight={5}>
                    <GridItem
                        label="Data da Atualização"
                        value={
                            empresa.identificacao.data_atualizacao
                                ? formatDate(empresa.identificacao.data_atualizacao, 'dd/MM/yyyy')
                                : '-'
                        }
                        xs={12}
                    />
                    <GridItem label="CNPJ" value={empresa.identificacao.cnpj} xs={12} />
                </Grid>
            )}
            <Identificacao empresa={empresa} />
            <Endereco empresa={empresa} />
            <Contatos empresa={empresa} />

            <ControleSocietario controleSocietario={empresa.controle_societario} />
            <ControleAdministracao controleAdministracao={empresa.controle_administracao} />
            <ControleParticipacoes controleParticipacoes={empresa.controle_participacoes} />
            <Consultas consultas={empresa.consultas_serasa.qtdePorMes} />
            <PendenciasFinanceiras pendenciasFinanceiras={empresa.pedencias_financeiras} />
            <DividaVencida dividaVencida={empresa.divida_vencida} />
            <AcaoJudicial acaoJudicial={empresa.acao_judicial} />
            <Protesto protesto={empresa.protesto} />
        </Paper>
    )
}
